import dayjs from 'dayjs'
import {ToDo, dateFormat} from '../../entities/todoList'
import type {ToDoSortingField} from './ToDoPageFilters'

// Deleting a custom task type leaves the reference behind on the tasks that
// used it, so the type is not always there to be named.
function toDoTypeName(todo: ToDo) {
  const type = todo.type
  if (!type || !type.type) {
    return ''
  }

  return type.type === 'custom' ? type.customToDoType?.name || '' : type.type
}

// the task is filed under whichever of its plants comes first alphabetically
function firstPlantName(todo: ToDo) {
  const plants = todo.plants
  if (!plants || plants.length === 0) {
    return ''
  }

  return [...plants].sort((p1, p2) => (p1.name || '').localeCompare(p2.name || ''))[0].name || ''
}

export function sortToDo(todos: ToDo[], sortingField: ToDoSortingField, sortingDirection: boolean) {
  const sortedToDos = todos.sort((todo1, todo2) => {
    if (sortingField === 'plants') {
      const plant1 = firstPlantName(todo1)
      const plant2 = firstPlantName(todo2)
      return sortingDirection ? plant1.localeCompare(plant2) : plant1.localeCompare(plant2) * -1
    } else if (sortingField === 'taskType') {
      const type1 = toDoTypeName(todo1)
      const type2 = toDoTypeName(todo2)
      return sortingDirection ? type1.localeCompare(type2) : type1.localeCompare(type2) * -1
    } else if (sortingField === 'date') {
      if (
        dayjs(todo1.targetStartDateUtc, dateFormat) < dayjs(todo2.targetStartDateUtc, dateFormat)
      ) {
        return sortingDirection ? -1 : 1
      } else if (
        dayjs(todo1.targetStartDateUtc, dateFormat) > dayjs(todo2.targetStartDateUtc, dateFormat)
      ) {
        return sortingDirection ? 1 : -1
      } else {
        return 0
      }
    }
    return 0
  })
  return sortedToDos
}
